module.exports = __webpack_public_path__ + "static/img/girl.0f3f4304.png";